import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

export interface ICreatePasswordRequestAction {
  data: {
    createPasswordToken: string;
    password: string;
    userData: {
      client: string;
      token: string;
      uid: string;
    };
    verifyPassword: string;
  };
  functions: {
    error: (err: any) => void;
    navigateTo: () => void;
  };
}

function createPasswordRequest(
  draft: Draft<IAuthData>,
  _: PayloadAction<ICreatePasswordRequestAction>,
) {
  draft.createPassword.config.isLoading = true;
}

export default createPasswordRequest;
